const MORE_FROM_LEXIS_FIELDS = {
    'AKAs/Identity[]/DriverLicenses/DriverLicense[]': [
        ['ActiveDate', "Active date"],
        ['Address/Province', "Province (address)"],
        ['AddressChange', "Address change"],
        ['Attention', "Attention"],
        ['InactiveDate', "Inactive date"],
        ['Issuance', "Issuance"],
        ['MotorCycle', "Motor cycle"],
        ['NameChange', "Name change"],
        ['NonDMVSource', "Non DMV source"],
        ['OOSPrevState', "Out-of-state previous state"],
        ['OrigExpDate', "Original expiration date"],
        ['RestrictionsDelimited', "Restrictions delimited"],
        ['RestrictionsDetail/Restriction[]', "Restriction"],
    ],
    'CorporateAffiliations/Affiliation[]': [
        ['Address/Type', "Type (address)"],
    ],
    'ControlledSubstances/ControlledSubstance[]/ControlledSubstancesInfo/ControlledSubstanceInfo[]': [
        ['Name', "Name"],
    ],
    'Accidents/Accident[]/Vehicles/Item[]': [
        ['Cap', "Cap"],
        ['FR', "FR"],
        ['HowRemoved', "How removed"],
        ['Insurance', "Insurance"],
        ['Modified', "Modified"],
        ['MovingViolation', "Moving violation"],
        ['OwnerDriver', "Owner driver"],
        ['Placarded', "Placarded"],
        ['RemovedBy', "Removed by"],
        ['RoadwayLocation', "Roadway location"],
        ['TotalOccupants', "Total occupants"],
        ['TotalSaftyEquipments', "Total safety equipments"],
        ['TowedTrailer/EstimatedDamage', "Estimated damage (towed trailer)"],
        ['TowedTrailer/FRCap', "FR cap (towed trailer)"],
        ['TowedTrailer/IDNumber', "ID number (towed trailer)"],
        ['TowedTrailer/TagNumber', "Tag number (towed trailer)"],
        ['TravelDirection', "Travel direction"],
        ['TravelOn', "Travel on"],
        ['VehicleFirstDefect', "Vehicle first defect"],
        ['VehicleSecondDefect', "Vehicle second defect"],
    ],
    'Accidents/Accident[]': [
        ['AccidentLocation/Action', "Action (accident location)"],
        ['AccidentLocation/AtNodeNumber', "At node number (accident location)"],
        ['AccidentLocation/CodeableNoncodeable', "Codeable noncodeable (accident location)"],
        ['AccidentLocation/DirectionCityTown', "Direction city town (accident location)"],
        ['AccidentLocation/FootCityTown', "Foot city town (accident location)"],
        ['AccidentLocation/FootMilesFromIntersect', "Foot miles from intersect (accident location)"],
        ['AccidentLocation/FootMilesNode', "Foot miles node (accident location)"],
        ['AccidentLocation/FromNodeNumber', "From node number (accident location)"],
        ['AccidentLocation/IntersectDirectionOf', "Intersect direction of (accident location)"],
        ['AccidentLocation/MilesCityTown', "Miles city town (accident location)"],
        ['AccidentLocation/NextNodeRoadway', "Next node roadway (accident location)"],
        ['AccidentLocation/OfIntersectOf', "Of intersect of (accident location)"],
        ['AccidentLocation/StateRoadAccident', "State road accident (accident location)"],
        ['AccidentLocation/TypeFRCase', "Type FR case (accident location)"],
        ['Conditions/AccidentFault', "Accident fault (conditions)"],
        ['Conditions/AlcoholDrug', "Alcohol drug (conditions)"],
        ['Conditions/DamageSeverity', "Damage severity (conditions)"],
        ['Conditions/DividedUndivided', "Divided undivided (conditions)"],
        ['Conditions/FirstTrafficControl', "First traffic control (conditions)"],
        ['Conditions/InjurySeverity', "Injury severity (conditions)"],
        ['Conditions/Insurance', "Insurance (conditions)"],
        ['Conditions/LocationType', "Location type (conditions)"],
        ['Conditions/NumberOfLanes', "Number of lanes (conditions)"],
        ['Conditions/OnOffRoadway', "On off roadway (conditions)"],
        ['Conditions/Population', "Population (conditions)"],
        ['Conditions/RoadSystemId', "Road system id (conditions)"],
        ['Conditions/SecondTrafficControl', "Second traffic control (conditions)"],
        ['Conditions/ShoulderType', "Shoulder type (conditions)"],
        ['Conditions/SiteLocation', "Site location (conditions)"],
        ['Conditions/TrafficwayChar', "Trafficway char (conditions)"],
        ['PropertyDamages/Item[]/FRFixedObjectCap', "FR fixed object cap (item)"],
        ['PropertyDamages/Item[]/PropertyDamageNumber', "Property damage number (item)"],
        ['Statistics/TotalTarDamage', "Total tar damage (statistics)"],
    ],
    'Aircrafts/Aircraft[]': [
        ['AircraftInfo/Certification', "Certification (aircraft)"],
        ['AircraftInfo/CruisingSpeed', "Cruising speed (aircraft)"],
        ['DateFirstSeen', "Date first seen"],
        ['EngineInfo/FuelConsumption', "Fuel consumption (engine)"],
        ['EngineInfo/Horsepower', "Horsepower (engine)"],
        ['EngineInfo/ManufacturerName', "Manufacturer name (engine)"],
        ['EngineInfo/ModelName', "Model name (engine)"],
        ['LastActionDate', "Last action date"],
        ['Registrant/Address', "Address (registrant)"],
        ['Registrant/Name', "Name (registrant)"],
    ],
    'Bankruptcies/Bankruptcy[]': [
        ['Attorneys/Attorney[]/Addresses/Address[]', "Address (attorney)"],
        ['Attorneys/Attorney[]/Emails/Email[]', "Email (attorney)"],
        ['Attorneys/Attorney[]/Phones/Phone[]/Fax', "Fax (attorney phone)"],
        ['BarDate', "Bar date"],
        ['CaseStatus', "Case status"],
        ['CaseType', "Case type"],
        ['ClaimsDeadline', "Claims deadline"],
        ['CourtCode', "Court code"],
        ['Debtors/Debtor[]/ActivityReceipt', "Activity receipt (debtor)"],
        ['Debtors/Debtor[]/DateTransferred', "Date transferred (debtor)"],
        ['Debtors/Debtor[]/DateVacated', "Date vacated (debtor)"],
        ['Debtors/Debtor[]/DefendantType', "Defendant type (debtor)"],
        ['Debtors/Debtor[]/DispositionCode', "Disposition code (debtor)"],
        ['Debtors/Debtor[]/DispositionCodeDesc', "Disposition code description (debtor)"],
        ['Debtors/Debtor[]/DispositionType', "Disposition type (debtor)"],
        ['Debtors/Debtor[]/Names/Name[]/Type', "Type (debtor name)"],
        ['Debtors/Debtor[]/OriginalCounty', "Original county (debtor)"],
        ['Debtors/Debtor[]/SSNMatch', "SSN match (debtor)"],
        ['Debtors/Debtor[]/SSNMatchSource', "SSN match source (debtor)"],
        ['Debtors/Debtor[]/Screen', "Screen (debtor)"],
        ['Debtors/Debtor[]/ScreenDesc', "Screen description (debtor)"],
        ['Debtors/Debtor[]/StatusDate', "Status date (debtor)"],
        ['FilingStatus', "Filing status"],
        ['FilingType', "Filing type"],
        ['Meeting/Address', "Address (meeting)"],
        ['Meeting/Date', "Date (meeting)"],
        ['Meeting/Time', "Time (meeting)"],
        ['SplitCase', "Split case"],
        ['TransferIn', "Transfer in"],
        ['Trustees/Trustee[]/Addresses/Address[]', "Address (trustee)"],
    ],
    'BestInfo': [
        ['Phones/Phone[]/Carrier', "Carrier (phone)"],
        ['Phones/Phone[]/CarrierCity', "Carrier city (phone)"],
        ['Phones/Phone[]/CarrierState', "Carrier state (phone)"],
        ['Phones/Phone[]/FirstSeen', "First seen (phone)"],
        ['Phones/Phone[]/LastSeen', "Last seen (phone)"],
        ['Phones/Phone[]/Newtype', "Newtype (phone)"],
        ['Phones/Phone[]/Type', "Type (phone)"],
    ],
    'BestInfoSupplement': [
        ['AgeAtDeath', "Age at death"],
        ['DeathCounty', "Death county"],
        ['DeathState', "Death state"],
    ],
    'BpsReportAddresses/BpsReportAddress[]': [
        ['Phones/Phone[]/Carrier', "Carrier (phone)"],
        ['Phones/Phone[]/CarrierCity', "Carrier city (phone)"],
        ['Phones/Phone[]/CarrierState', "Carrier state (phone)"],
        ['Phones/Phone[]/DateFirstSeen', "Date first seen (phone)"],
        ['Phones/Phone[]/DateLastSeen', "Date last seen (phone)"],
        ['Phones/Phone[]/HighRiskIndicators/HighRiskIndicator[]/RiskCode', "Risk code (phone high risk indicator)"],
        ['Phones/Phone[]/Name', "Name (phone)"],
        ['Phones/Phone[]/PubNonpub', "Pub nonpub (phone)"],
        ['Properties/Property[]/Assessment/AirConditioning', "Air conditioning (property assessment)"],
        ['Properties/Property[]/Assessment/AirConditioningType', "Air conditioning type (property assessment)"],
        ['Properties/Property[]/Assessment/AssessedImprovementValue', "Assessed improvement value (property assessment)"],
        ['Properties/Property[]/Assessment/AssessedValueYear', "Assessed value year (property assessment)"],
        ['Properties/Property[]/Assessment/AssesseeRelationship', "Assessee relationship (property assessment)"],
        ['Properties/Property[]/Assessment/County', "County (property assessment)"],
        ['Properties/Property[]/Assessment/ExteriorWalls', "Exterior walls (property assessment)"],
        ['Properties/Property[]/Assessment/FipsCode', "Fips code (property assessment)"],
        ['Properties/Property[]/Assessment/GarageType', "Garage type (property assessment)"],
        ['Properties/Property[]/Assessment/Heating', "Heating (property assessment)"],
        ['Properties/Property[]/Assessment/HeatingFuelTypeCode', "Heating fuel type code (property assessment)"],
        ['Properties/Property[]/Assessment/HeatingFuelTypeDesc', "Heating fuel type description (property assessment)"],
        ['Properties/Property[]/Assessment/HomesteadHomeownerExemption', "Homestead homeowner exemption (property assessment)"],
        ['Properties/Property[]/Assessment/LandSquareFootage', "Land square footage (property assessment)"],
        ['Properties/Property[]/Assessment/LandUseCode', "Land use code (property assessment)"],
        ['Properties/Property[]/Assessment/LegalInfo/BriefDescription', "Brief description (property assessment legal)"],
        ['Properties/Property[]/Assessment/LegalInfo/LotNumber', "Lot number (property assessment legal)"],
        ['Properties/Property[]/Assessment/LegalInfo/Subdivision', "Subdivision (property assessment legal)"],
        ['Properties/Property[]/Assessment/MarketImprovementValue', "Market improvement value (property assessment)"],
        ['Properties/Property[]/Assessment/MarketLandValue', "Market land value (property assessment)"],
        ['Properties/Property[]/Assessment/MarketValueYear', "Market value year (property assessment)"],
        ['Properties/Property[]/Assessment/MortgageLender', "Mortgage lender (property assessment)"],
        ['Properties/Property[]/Assessment/MortgageLoanAmount', "Mortgage loan amount (property assessment)"],
        ['Properties/Property[]/Assessment/MortgageLoanType', "Mortgage loan type (property assessment)"],
        ['Properties/Property[]/Assessment/NoOfBaths', "Number of baths (property assessment)"],
        ['Properties/Property[]/Assessment/NoOfBedrooms', "Number of bedrooms (property assessment)"],
        ['Properties/Property[]/Assessment/NoOfPartialBaths', "Number of partial baths (property assessment)"],
        ['Properties/Property[]/Assessment/NoOfStories', "Number of stories (property assessment)"],
        ['Properties/Property[]/Assessment/NoOfStoriesDesc', "Number of stories description (property assessment)"],
        ['Properties/Property[]/Assessment/OwnerOccupied', "Owner occupied (property assessment)"],
        ['Properties/Property[]/Assessment/ParcelId', "Parcel id (property assessment)"],
        ['Properties/Property[]/Assessment/Pool', "Pool (property assessment)"],
        ['Properties/Property[]/Assessment/PriorRecordingDate', "Prior recording date (property assessment)"],
        ['Properties/Property[]/Assessment/RecordType', "Record type (property assessment)"],
        ['Properties/Property[]/Assessment/RecorderBookNumber', "Recorder book number (property assessment)"],
        ['Properties/Property[]/Assessment/RecorderPageNumber', "Recorder page number (property assessment)"],
        ['Properties/Property[]/Assessment/RecordingDate', "Recording date (property assessment)"],
        ['Properties/Property[]/Assessment/RoofType', "Roof type (property assessment)"],
        ['Properties/Property[]/Assessment/SaleDate', "Sale date (property assessment)"],
        ['Properties/Property[]/Assessment/SalesPrice', "Sales price (property assessment)"],
        ['Properties/Property[]/Assessment/SourcePropertyRecord/LivingSquareFeet', "Living square feet (property assessment source)"],
        ['Properties/Property[]/Assessment/StateCode', "State code (property assessment)"],
        ['Properties/Property[]/Assessment/TaxAmount', "Tax amount (property assessment)"],
        ['Properties/Property[]/Assessment/YearBuilt', "Year built (property assessment)"],
        ['Properties/Property[]/DataSource', "Data source (property)"],
        ['Properties/Property[]/Deed/ArmResetDate', "Arm reset date (property deed)"],
        ['Properties/Property[]/Deed/CityTransferTax', "City transfer tax (property deed)"],
        ['Properties/Property[]/Deed/ContractDate', "Contract date (property deed)"],
        ['Properties/Property[]/Deed/County', "County (property deed)"],
        ['Properties/Property[]/Deed/CountyTransferTax', "County transfer tax (property deed)"],
        ['Properties/Property[]/Deed/DeedSourcePropertyRecord/IrisApn', "Iris parcel number (property deed source)"],
        ['Properties/Property[]/Deed/DeedSourcePropertyRecord/MortgageDeedType', "Mortgage deed type (property deed source)"],
        ['Properties/Property[]/Deed/DeedSourcePropertyRecord/MortgageDeedTypeDesc', "Mortgage deed type description (property deed source)"],
        ['Properties/Property[]/Deed/DeedSourcePropertyRecord/MortgageTerm', "Mortgage term (property deed source)"],
        ['Properties/Property[]/Deed/DeedSourcePropertyRecord/MortgageTermCode', "Mortgage term code (property deed source)"],
        ['Properties/Property[]/Deed/DeedSourcePropertyRecord/MortgageTermCodeDesc', "Mortgage term code description (property deed source)"],
        ['Properties/Property[]/Deed/DeedSourcePropertyRecord/TransactionType', "Transaction type (property deed source)"],
        ['Properties/Property[]/Deed/DeedSourcePropertyRecord/TransactionTypeDesc', "Transaction type description (property deed source)"],
        ['Properties/Property[]/Deed/DocumentNumber', "Document number (property deed)"],
        ['Properties/Property[]/Deed/DocumentTypeCode', "Document type code (property deed)"],
        ['Properties/Property[]/Deed/DocumentTypeDesc', "Document type description (property deed)"],
        ['Properties/Property[]/Deed/FirstTdDueDate', "First trust deed due date (property deed)"],
        ['Properties/Property[]/Deed/FirstTdInterestRate', "First trust deed interest rate (property deed)"],
        ['Properties/Property[]/Deed/FirstTdLoanAmount', "First trust deed loan amount (property deed)"],
        ['Properties/Property[]/Deed/FirstTdLoanType', "First trust deed loan type (property deed)"],
        ['Properties/Property[]/Deed/LandLotSize', "Land lot size (property deed)"],
        ['Properties/Property[]/Deed/LegalInfo/BriefDescription', "Brief description (property deed legal)"],
        ['Properties/Property[]/Deed/LenderInfo/Name', "Name (property deed lender)"],
        ['Properties/Property[]/Deed/MortgageDeedSubType', "Mortgage deed sub type (property deed)"],
        ['Properties/Property[]/Deed/ParcelId', "Parcel id (property deed)"],
        ['Properties/Property[]/Deed/PropertyUseCode', "Property use code (property deed)"],
        ['Properties/Property[]/Deed/PropertyUseDesc', "Property use description (property deed)"],
        ['Properties/Property[]/Deed/RecorderBookNumber', "Recorder book number (property deed)"],
        ['Properties/Property[]/Deed/RecorderPageNumber', "Recorder page number (property deed)"],
        ['Properties/Property[]/Deed/RecordingDate', "Recording date (property deed)"],
        ['Properties/Property[]/Deed/SalesPrice', "Sales price (property deed)"],
        ['Properties/Property[]/Deed/TitleCompany', "Title company (property deed)"],
        ['Properties/Property[]/Deed/TotalTransferTax', "Total transfer tax (property deed)"],
        ['Properties/Property[]/Deed/TypeFinancing', "Type financing (property deed)"],
        ['Properties/Property[]/Deed/TypeFinancingDesc', "Type financing description (property deed)"],
        ['Properties/Property[]/RecordType', "Record type (property)"],
        ['Properties/Property[]/RecordTypeDesc', "Record type description (property)"],
    ],
    'CriminalRecords/Criminal[]': [
        ['AKAs/Name[]', "Name"],
        ['Activities/Activity[]/Date', "Date (activity)"],
        ['Activities/Activity[]/Description', "Description (activity)"],
        ['Offenses/Offense[]/Appeal/Date', "Date (offense appeal)"],
        ['Offenses/Offense[]/Arrest/CaseNumber', "Case number (offense arrest)"],
        ['Offenses/Offense[]/Arrest/DispositionDate', "Disposition date (offense arrest)"],
        ['Offenses/Offense[]/CaseNumber', "Case number (offense)"],
        ['Offenses/Offense[]/CaseType', "Case type (offense)"],
        ['Offenses/Offense[]/County', "County (offense)"],
        ['Offenses/Offense[]/Court/SuspendedFine', "Suspended fine (offense court)"],
        ['Offenses/Offense[]/OffenseType', "Offense type (offense)"],
    ],
    'FAACertifications/Certification[]': [
        ['Address', "Address"],
    ],
    'FictitiousBusinesses/FictitiousBusiness[]': [
        ['Business/Phone', "Phone (business)"],
        ['Business/SICCode', "SIC code (business)"],
        ['OriginalFilingDate', "Original filing date"],
        ['OriginalFilingNumber', "Original filing number"],
        ['Owners/Owner[]/Address', "Address (owner)"],
        ['Owners/Owner[]/CharterNumber', "Charter number (owner)"],
        ['Owners/Owner[]/ContactType', "Contact type (owner)"],
        ['Owners/Owner[]/Name', "Name (owner)"],
        ['Owners/Owner[]/NameFormat', "Name format (owner)"],
        ['Owners/Owner[]/Phone', "Phone (owner)"],
        ['Owners/Owner[]/Status', "Status (owner)"],
    ],
    'FirearmExplosives/FirearmExplosive[]': [
        ['IRSRegion', "IRS region"],
        ['RawLicenseName', "Raw license name"],
    ],
    'Foreclosures/Foreclosure[]': [
        ['Attorney', "Attorney"],
        ['AttorneyPhoneNumber', "Attorney phone number"],
        ['CurrentImprovementValue', "Current improvement value"],
        ['CurrentLandValue', "Current land value"],
        ['Defendants/Defendant[]/CompanyName', "Company name (defendant)"],
        ['Defendants/Defendant[]/Name', "Name (defendant)"],
        ['DocumentBook', "Document book"],
        ['DocumentPages', "Document pages"],
        ['LandSize', "Land size"],
        ['LandUsage', "Land usage"],
        ['LegalDescription', "Legal description"],
        ['LivingSize', "Living size"],
        ['SubdivisionName', "Subdivision name"],
        ['TitleCompany', "Title company"],
        ['Trustee', "Trustee"],
        ['YearBuilt', "Year built"],
    ],
    'Imposters/Imposter[]': [
        ['AKAs/Identity[]/DeathVerificationCode', "Death verification code (identity)"],
    ],
    'LiensJudgments/LienJudgment[]': [
        ['DebtorAttorneys/Attorney[]/Address', "Address (attorney)"],
        ['DebtorAttorneys/Attorney[]/Phone', "Phone (attorney)"],
        ['FilingState', "Filing state"],
        ['FilingStatus', "Filing status"],
        ['JudgeSatisfiedDate', "Judge satisfied date"],
        ['LegalBlock', "Legal block"],
        ['LegalLot', "Legal lot"],
        ['ThirdParties/ThirdParty[]/OriginName', "Origin name (third party)"],
        ['ThirdParties/ThirdParty[]/ParsedParties/Party[]/CompanyName', "Company name (third party)"],
    ],
    'NoticesOfDefaults/NoticeOfDefaults[]': [
        ['Defendants/Defendant[]/CompanyName', "Company name (defendant)"],
        ['Defendants/Defendant[]/Name', "Name (defendant)"],
        ['Site2Address', "Site2 address"],
        ['VendorSource', "Vendor source"],
    ],
    'ProfessionalLicenses/ProfessionalLicense[]': [
        ['ContinueEducation', "Continue education"],
        ['Education1/Curriculum', "Curriculum (education1)"],
        ['Education2/Degree', "Degree (education2)"],
        ['LicenseObtainedBy', "License obtained by"],
        ['Name', "Name"],
        ['PracticeHours', "Practice hours"],
    ],
    'Properties/Property[]': [
        ['Assessment/AirConditioning', "Air conditioning (assessment)"],
        ['Assessment/AirConditioningType', "Air conditioning type (assessment)"],
        ['Assessment/AssessedImprovementValue', "Assessed improvement value (assessment)"],
        ['Assessment/AssesseeOwnershipRights', "Assessee ownership rights (assessment)"],
        ['Assessment/AssesseeRelationship', "Assessee relationship (assessment)"],
        ['Assessment/ExteriorWalls', "Exterior walls (assessment)"],
        ['Assessment/FipsCode', "Fips code (assessment)"],
        ['Assessment/GarageType', "Garage type (assessment)"],
        ['Assessment/Heating', "Heating (assessment)"],
        ['Assessment/HeatingFuelTypeCode', "Heating fuel type code (assessment)"],
        ['Assessment/HeatingFuelTypeDesc', "Heating fuel type description (assessment)"],
        ['Assessment/LandSquareFootage', "Land square footage (assessment)"],
        ['Assessment/LandUseCode', "Land use code (assessment)"],
        ['Assessment/LegalInfo/BriefDescription', "Brief description (assessment legal)"],
        ['Assessment/LegalInfo/LotNumber', "Lot number (assessment legal)"],
        ['Assessment/LegalInfo/Subdivision', "Subdivision (assessment legal)"],
        ['Assessment/MarketImprovementValue', "Market improvement value (assessment)"],
        ['Assessment/MarketLandValue', "Market land value (assessment)"],
        ['Assessment/NoOfBaths', "Number of baths (assessment)"],
        ['Assessment/NoOfBedrooms', "Number of bedrooms (assessment)"],
        ['Assessment/NoOfPartialBaths', "Number of partial baths (assessment)"],
        ['Assessment/NoOfStories', "Number of stories (assessment)"],
        ['Assessment/NoOfStoriesDesc', "Number of stories description (assessment)"],
        ['Assessment/Pool', "Pool (assessment)"],
        ['Assessment/PriorRecordingDate', "Prior recording date (assessment)"],
        ['Assessment/RecordType', "Record type (assessment)"],
        ['Assessment/RecorderBookNumber', "Recorder book number (assessment)"],
        ['Assessment/RecorderPageNumber', "Recorder page number (assessment)"],
        ['Assessment/RecordingDate', "Recording date (assessment)"],
        ['Assessment/RoofType', "Roof type (assessment)"],
        ['Assessment/StateCode', "State code (assessment)"],
        ['DataSource', "Data source"],
        ['Deed/ArmResetDate', "Arm reset date (deed)"],
        ['Deed/CityTransferTax', "City transfer tax (deed)"],
        ['Deed/CountyTransferTax', "County transfer tax (deed)"],
        ['Deed/DeedSourcePropertyRecord/IrisApn', "Iris parcel number (deed source property)"],
        ['Deed/DeedSourcePropertyRecord/MortgageDeedType', "Mortgage deed type (deed source property)"],
        ['Deed/DeedSourcePropertyRecord/MortgageDeedTypeDesc', "Mortgage deed type description (deed source property)"],
        ['Deed/DeedSourcePropertyRecord/MortgageTerm', "Mortgage term (deed source property)"],
        ['Deed/DeedSourcePropertyRecord/MortgageTermCode', "Mortgage term code (deed source property)"],
        ['Deed/DeedSourcePropertyRecord/MortgageTermCodeDesc', "Mortgage term code description (deed source property)"],
        ['Deed/DeedSourcePropertyRecord/TransactionType', "Transaction type (deed source property)"],
        ['Deed/DocumentNumber', "Document number (deed)"],
        ['Deed/DocumentTypeCode', "Document type code (deed)"],
        ['Deed/DocumentTypeDesc', "Document type description (deed)"],
        ['Deed/FirstTdDueDate', "First trust deed due date (deed)"],
        ['Deed/FirstTdInterestRate', "First trust deed interest rate (deed)"],
        ['Deed/LandLotSize', "Land lot size (deed)"],
        ['Deed/LegalInfo/BriefDescription', "Brief description (deed legal)"],
        ['Deed/LenderInfo/Name', "Name (deed lender)"],
        ['Deed/MortgageDeedSubType', "Mortgage deed sub type (deed)"],
        ['Deed/PropertyUseCode', "Property use code (deed)"],
        ['Deed/RecorderBookNumber', "Recorder book number (deed)"],
        ['Deed/RecorderPageNumber', "Recorder page number (deed)"],
        ['Deed/RecordingDate', "Recording date (deed)"],
        ['Deed/TitleCompany', "Title company (deed)"],
        ['Deed/TotalTransferTax', "Total transfer tax (deed)"],
        ['Deed/TypeFinancing', "Type financing (deed)"],
        ['Deed/TypeFinancingDesc', "Type financing description (deed)"],
        ['Entities/Entity[]/OriginalNames/OriginalName[]/IdDescription', "Id description (entity original name)"],
        ['Entities/Entity[]/OriginalNames/OriginalName[]/Name', "Name (entity original name)"],
        ['Entities/Entity[]/OriginalNames/OriginalName[]/NameSeq', "Name seq (entity original name)"],
        ['RecordType', "Record type"],
        ['RecordTypeDesc', "Record type description"],
    ],
    'SexualOffenses/SexualOffense[]': [
        ['AKAs/AKA[]/First', "First (AKA)"],
        ['AKAs/AKA[]/Full', "Full (AKA)"],
        ['AKAs/AKA[]/Last', "Last (AKA)"],
        ['AKAs/AKA[]/Middle', "Middle (AKA)"],
        ['AKAs/AKA[]/Suffix', "Suffix (AKA)"],
        ['AdditionalComment1', "Additional comment1"],
        ['Address', "Address"],
        ['Convictions/Conviction[]/CourtCaseNumber', "Court case number (conviction)"],
        ['Convictions/Conviction[]/OffenseDate', "Offense date (conviction)"],
        ['DOB', "DOB"],
        ['DOB2', "DOB2"],
        ['DriverLicenseState', "Driver license state"],
        ['Employer/Address1', "Address1 (employer)"],
        ['IdNumbers/DocNumber', "Doc number (id numbers)"],
        ['IdNumbers/SORNumber', "SOR number (id numbers)"],
        ['Name', "Name"],
        ['PoliceAgency/Name', "Name (police agency)"],
        ['RecordType', "Record type"],
        ['Registration/Address1', "Address1 (registration)"],
        ['Registration/Address2', "Address2 (registration)"],
        ['Registration/Address3', "Address3 (registration)"],
        ['Registration/Address4', "Address4 (registration)"],
        ['Registration/Date1Type', "Date1 type (registration)"],
        ['Vehicle1', "Vehicle1"],
    ],
    'UCCFilings/UCCFiling[]': [
        ['Assignees/Assignee[]/Addresses/Address[]', "Address (assignee)"],
        ['Assignees/Assignee[]/ParsedParties/Party[]/Name', "Name (assignee party)"],
        ['Collaterals/Collateral[]/Address', "Address (collateral)"],
        ['Collaterals/Collateral[]/Count', "Count (collateral)"],
        ['Collaterals/Collateral[]/SerialNumber', "Serial number (collateral)"],
        ['Debtors/Debtor[]/ParsedParties/Party[]/CorporateNumber', "Corporate number (debtor party)"],
        ['Debtors/Debtor[]/ParsedParties/Party[]/CorporateType', "Corporate type (debtor party)"],
        ['Debtors/Debtor[]/ParsedParties/Party[]/Name', "Name (debtor party)"],
        ['FilingOffices/Office[]/Address', "Address (office)"],
        ['Filings/Filing[]/ContractType', "Contract type (filing)"],
        ['Filings/Filing[]/FilingStatus', "Filing status (filing)"],
        ['Filings/Filing[]/Pages', "Pages (filing)"],
        ['OriginFilingType', "Origin filing type"],
        ['Secureds/Secured[]/Addresses/Address[]', "Address (secured)"],
        ['Secureds/Secured[]/Addresses/Address[]/IsForeign', "Is foreign (secured address)"],
        ['Secureds/Secured[]/ParsedParties/Party[]/CorporateType', "Corporate type (secured party)"],
        ['Secureds/Secured[]/ParsedParties/Party[]/Name', "Name (secured party)"],
        ['Signers/Signer[]/Name', "Name (signer)"],
    ],
    'Vehicles/Vehicle[]': [
        ['Lessees/Lessee[]/HistoryDescription', "History description (lessee)"],
        ['Lessees/Lessee[]/LesseeInfo/BusinessName', "Business name (lessee)"],
        ['Lessees/Lessee[]/LesseeInfo/Name', "Name (lessee)"],
        ['Lessors/Lessor[]/HistoryDescription', "History description (lessor)"],
        ['Lessors/Lessor[]/LessorInfo/BusinessName', "Business name (lessor)"],
        ['Lessors/Lessor[]/LessorInfo/Name', "Name (lessor)"],
        ['LienHolders/LienHolder[]/HistoryDescription', "History description (lien holder)"],
        ['LienHolders/LienHolder[]/LienHolderInfo/Address', "Address (lien holder)"],
        ['LienHolders/LienHolder[]/LienHolderInfo/Name', "Name (lien holder)"],
        ['Owners/Owner[]/OwnerInfo/Name', "Name (owner)"],
        ['Owners/Owner[]/OwnerInfo/ReportedName', "Reported name (owner)"],
        ['Owners/Owner[]/SourceDateFirstSeen', "Source date first seen (owner)"],
        ['Owners/Owner[]/SourceDateLastSeen', "Source date last seen (owner)"],
        ['Owners/Owner[]/TitleInfo/Number', "Number (owner title)"],
        ['Owners/Owner[]/TitleInfo/PreviousIssueDate', "Previous issue date (owner title)"],
        ['Owners/Owner[]/TitleInfo/StatusCode', "Status code (owner title)"],
        ['Owners/Owner[]/TitleInfo/StatusDesc', "Status description (owner title)"],
        ['Registrants/Registrant[]/RegistrantInfo/Name', "Name (registrant)"],
        ['Registrants/Registrant[]/RegistrantInfo/ReportedName', "Reported name (registrant)"],
        ['Registrants/Registrant[]/RegistrationInfo/DecalNumber', "Decal number (registrant registration)"],
        ['Registrants/Registrant[]/RegistrationInfo/DecalYear', "Decal year (registrant registration)"],
        ['Registrants/Registrant[]/RegistrationInfo/LatestEffectiveDate', "Latest effective date (registrant registration)"],
        ['Registrants/Registrant[]/RegistrationInfo/LicensePlateTypeCode', "License plate type code (registrant registration)"],
        ['Registrants/Registrant[]/RegistrationInfo/LicenseState', "License state (registrant registration)"],
        ['Registrants/Registrant[]/RegistrationInfo/PreviousLicensePlate', "Previous license plate (registrant registration)"],
        ['Registrants/Registrant[]/RegistrationInfo/PreviousLicenseState', "Previous license state (registrant registration)"],
        ['Registrants/Registrant[]/RegistrationInfo/StatusDesc', "Status description (registrant registration)"],
        ['Registrants/Registrant[]/RegistrationInfo/TrueLicensePlate', "True license plate (registrant registration)"],
    ],
    'WaterCrafts/WaterCraft[]': [
        ['Description/Class', "Class (description)"],
        ['Description/CoastGuardNumber', "Coast guard number (description)"],
        ['Description/Color1', "Color1 (description)"],
        ['Description/Color2', "Color2 (description)"],
        ['Description/Dealer', "Dealer (description)"],
        ['Description/HailingPort/Name', "Name (description hailing port)"],
        ['Description/HailingPort/Province', "Province (description hailing port)"],
        ['Description/HailingPort/State', "State (description hailing port)"],
        ['Description/HomePort/Name', "Name (description home port)"],
        ['Description/InternationalTonnageConvention/Breadth', "Breadth (description international tonnage convention)"],
        ['Description/InternationalTonnageConvention/Depth', "Depth (description international tonnage convention)"],
        ['Description/InternationalTonnageConvention/Length', "Length (description international tonnage convention)"],
        ['Description/Manufacture/HullBuildAddress', "Hull build address (description manufacture)"],
        ['Description/PurchaseDate', "Purchase date (description)"],
        ['Description/RegisteredMeasurements/Breadth', "Breadth (description registered measurements)"],
        ['Description/RegisteredMeasurements/Depth', "Depth (description registered measurements)"],
        ['Description/RegisteredMeasurements/GrossTons', "Gross tons (description registered measurements)"],
        ['Description/RegisteredMeasurements/NetTons', "Net tons (description registered measurements)"],
        ['Description/StatePurchased', "State purchased (description)"],
        ['Description/Toilet', "Toilet (description)"],
        ['Description/VesselId', "Vessel id (description)"],
        ['Description/VesselName', "Vessel name (description)"],
        ['Description/Width', "Width (description)"],
        ['Engines/Engine[]', "Engine"],
        ['Engines/Engine[]/HorsePower', "Horse power (engine)"],
        ['Engines/Engine[]/Make', "Make (engine)"],
        ['Engines/Engine[]/Number', "Number (engine)"],
        ['LienHolders/LienHolder[]/Address', "Address (lien holder)"],
        ['LienHolders/LienHolder[]/LienDate', "Lien date (lien holder)"],
        ['LienHolders/LienHolder[]/Name', "Name (lien holder)"],
        ['NonDMVSource', "Non DMV source"],
        ['Owners/Owner[]/Address/Province', "Province (owner address)"],
        ['Owners/Owner[]/CompanyName', "Company name (owner)"],
        ['Owners/Owner[]/Name', "Name (owner)"],
        ['Owners/Owner[]/NameType', "Name type (owner)"],
        ['Registration/DecalNumber', "Decal number (registration)"],
        ['Registration/ExpirationDate', "Expiration date (registration)"],
        ['Registration/RegistrateDate', "Registration date (registration)"],
        ['Registration/RenewDate', "Renew date (registration)"],
        ['Title/IssueDate', "Issue date (title)"],
        ['Title/Number', "Number (title)"],
        ['Title/State', "State (title)"],
        ['Title/Status', "Status (title)"],
        ['Title/TransactionType', "Transaction type (title)"],
        ['Title/Type', "Type (title)"],
    ],
    'PossibleStudentRecords/PossibleStudentRecord[]': [
        ['AddressAtCollege/Zip4', "Zip4 (address at college)"],
    ],
    'UtilitiesData/UtilityData[]': [
        ['DualAddress', "Dual address"],
    ],
}

export default MORE_FROM_LEXIS_FIELDS
